import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-unmute.svg";
import * as styles from "./Icon.module.scss";

type UnmuteProps = React.SVGProps<SVGSVGElement>;

export const Unmute = ({ className, ...props }: UnmuteProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
